<template>
  <div class="card p-2" style="min-height: calc(100vh - 185px);">
      <div class="d-flex flex-wrap justify-content-between align-item-center">
          <h3>Performance Component Setup</h3>
          <div class="gx-1">
              <button
                  @click="onClickToOpenModal('group')"
                  class="btn btn-primary waves-effect waves-float waves-light me-1"
              >Add Group
              </button>
          </div>
      </div>
      <div class="mt-2"></div>
      <hr>
      <TreeBrowser
          v-for="(item, i) in activityList"
          :key="i"
          :node="item"
      />

      <PerformanceComponentAddOrEditModal
        v-if="store.state.isModalOpen"
        :title="title"
        :activityType="activityType"
        :calculationTypeList="calculationTypeList"
        :defaultTypeList="defaultTypeList"
        :statusList="statusList"
        @onSubmit="getActivityTree"
        :parent="parent"
        :editData="singleActivity"
      />

      <p v-if="!activityList.length" class="text-center mt-5">No data</p>  
      
      <Loader v-if="loading"/>
  </div>
</template>

<script setup>

import TreeBrowser      from '@/components/molecule/company/hrm-payroll/performance-component/PerformanceComponentTreeBrowser'
import Loader           from '@/components/atom/LoaderComponent'
import { onMounted, onUnmounted, ref } from 'vue';
import { useRoute } from 'vue-router';
import { getCurrentInstance } from 'vue';
import PerformanceComponentAddOrEditModal from '@/components/molecule/company/hrm-payroll/performance-component/PerformanceComponentAddOrEditModal'
import { useStore } from 'vuex';
import handleHrPayroll from "@/services/modules/hrPayroll/hrPayroll";

const { appContext } = getCurrentInstance()
const emitter = appContext.config.globalProperties.emitter
const store = useStore();
const {
  getPerformanceComponentSetupTree,
  fetchTypes,
  fetchSinglePerformanceComponentSetup
} = handleHrPayroll()
const route = useRoute();
const activityList = ref([]);
const calculationTypeList = ref([]);
const defaultTypeList = ref([]);
const statusList = ref([]);
const loading = ref(false);
const title = ref('');
const activityType = ref('');
const parent = ref(null);
const child = ref(null);
const singleActivity = ref(null);

const onClickToOpenModal = (headType = 'group') => {
  singleActivity.value = null;
  activityType.value = headType;
  title.value = headType === 'group' ? 'Add Performance Group' : 'Add Performance Head';
  store.state.isModalOpen = true;
}

const getQuery = () => {
    let query = `?company_id=${route.params.companyId}`;
    return query;
}

const getTypes = async () => {
  let query = getQuery();
  await fetchTypes(query).then(res => {
    if (!res.status){
      calculationTypeList.value = [];
      defaultTypeList.value = [];
      statusList.value = [];
      return
    }

    if (res.data && res.data.performanceComponentCalculationType) {
      calculationTypeList.value = res.data.performanceComponentCalculationType;
    }

    if (res.data && res.data.performanceComponentDefaultType) {
      defaultTypeList.value = res.data.performanceComponentDefaultType;
    }

    if (res.data && res.data.status) {
      statusList.value = res.data.status.filter(
          item => item.value === 'active' || item.value === 'inactive'
      );
    }

  }).catch(err => {
    console.log(err)
  })
}

const getActivityTree = async () => {
    const query = getQuery();
    loading.value = true

    await getPerformanceComponentSetupTree(query).then(res => {
      activityList.value = [];

      if (res.status){
        activityList.value = res.data;
      }
    }).catch(err => {
        console.log(err)
    }).finally(() => {
        loading.value = false
    })
}

const getSingleActivity = async (id) => {
    singleActivity.value = null;
    const query = getQuery();
    loading.value = true

    await fetchSinglePerformanceComponentSetup(id, query).then(res => {
      if (res.status){
        singleActivity.value = res.data;
      }
    }).catch(err => {
        console.log(err)
    }).finally(() => {
        loading.value = false
    })
}

const handleAddGroup = (data) => {
  parent.value = data;
  activityType.value = 'childGroup';
  singleActivity.value = null
  store.state.isModalOpen = true;
}

const handleAddLocation = (data) => {
  parent.value = data;
  activityType.value = 'endpoint';
  singleActivity.value = null
  store.state.isModalOpen = true;
}

const handleGroupUpdate = async (data) => {
  await getSingleActivity(data.data.id);

  if(singleActivity.value && singleActivity.value.parent) {
    parent.value = singleActivity.value.parent;
  }

  activityType.value = 'group'
  store.state.isModalOpen = true;
}

const handleLocationUpdate = async (data) => {
  await getSingleActivity(data.data.id);

  if(singleActivity.value && singleActivity.value.parent) {
    parent.value = singleActivity.value.parent;
  }

  store.state.isModalOpen = true;
}

onMounted(() => {
  getActivityTree();
  getTypes()
  
  emitter.on('onClickAddGroup', handleAddGroup)
  emitter.on('onClickAddLocation', handleAddLocation)
  emitter.on('onGroupUpdate', handleGroupUpdate)
  emitter.on('onLocationUpdate', handleLocationUpdate)
})

onUnmounted(() => {
  emitter.off('onClickAddGroup', handleAddGroup)
  emitter.off('onClickAddLocation', handleAddLocation)
  emitter.off('onGroupUpdate', handleGroupUpdate)
  emitter.off('onLocationUpdate', handleLocationUpdate)
})

</script>
  